export default __webpack_public_path__ + "media/images/images/carousel/30-ad0b846e31c2b0211d5bec344f32b5f0.jpg";